import React from "react";
import { useSelector, useDispatch } from "react-redux";

import { authActions } from "../store";

import { FiLogOut } from "react-icons/fi";

import { Dropdown } from "primereact/dropdown";
import modelObj from "../../utils/cookieUtils";

import { AiOutlineMenuFold, AiOutlineMenuUnfold } from "react-icons/ai";

export default function TopBar(props) {
    const sidebarHandler = (evt) => {};
    const authUser = useSelector((x) => x.auth.accessToken);
    const dispatch = useDispatch();
    const logout = () => dispatch(authActions.logout());

    // only show nav when logged in
    if (!authUser) return null;

    const useLangs = [
        { value: "kr", dataLang: "kr", label: "한국어" },
        { value: "en", dataLang: "en", label: "English" },
    ];

    const changeUseLang = (evt) => {
        var currLang = evt.target.value;
        props.setUseLang(currLang);
        modelObj.addItemOnLocalStorage("language", currLang);
        modelObj.renderLanguage();
    };

    return (
        <nav
            id="TopNavigationBar"
            className="navbar navbar-expand navbar-light topbar mb-4 static-top shadow"
        >
            <button
                id="sidebarToggleTop"
                className="btn rounded-circle mr-3"
                style={{ padding: "0px", border: "none" }}
                onClick={props.sidebarHandler}
            >
                {/* <i className="fa fa-bars"></i> */}
                {props.isToggled === "toggled" ? (
                    <AiOutlineMenuUnfold style={{ fontSize: "30px" }} />
                ) : (
                    <AiOutlineMenuFold style={{ fontSize: "30px" }} />
                )}
            </button>

            {/* <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
				<div className="input-group">
					<input
						type="text"
						className="form-control bg-light border-0 small"
						placeholder="Search for..."
						aria-label="Search"
						aria-describedby="basic-addon2"
					/>
					<div className="input-group-append">
						<button className="btn btn-primary" type="button">
							<i className="fas fa-search fa-sm"></i>
						</button>
					</div>
				</div>
			</form> */}

            <ul className="navbar-nav ml-auto">
                {/* <li className="nav-item dropdown no-arrow d-sm-none">
					<a
						className="nav-link dropdown-toggle"
						href="{() => false}"
						id="searchDropdown"
						role="button"
						data-toggle="dropdown"
						aria-haspopup="true"
						aria-expanded="false"
					>
						<i className="fas fa-search fa-fw"></i>
					</a>
					<div
						className="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in"
						aria-labelledby="searchDropdown"
					>
						<form className="form-inline mr-auto w-100 navbar-search">
							<div className="input-group">
								<input
									type="text"
									className="form-control bg-light border-0 small"
									placeholder="Search for..."
									aria-label="Search"
									aria-describedby="basic-addon2"
								/>
								<div className="input-group-append">
									<button
										className="btn btn-primary"
										type="button"
									>
										<i className="fas fa-search fa-sm"></i>
									</button>
								</div>
							</div>
						</form>
					</div>
				</li> */}

                {/* <li className="nav-item dropdown no-arrow mx-1">
					<a
						className="nav-link dropdown-toggle"
						href="{()=>false}"
						id="alertsDropdown"
						role="button"
						data-toggle="dropdown"
						aria-haspopup="true"
						aria-expanded="false"
					>
						<i className="fas fa-bell fa-fw"></i>
						<span className="badge badge-danger badge-counter">
							3+
						</span>
					</a>
					<div
						className="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
						aria-labelledby="alertsDropdown"
					>
						<h6 className="dropdown-header">Alerts Center</h6>
						<a
							className="dropdown-item d-flex align-items-center"
							href="{()=>false}"
						>
							<div className="mr-3">
								<div className="icon-circle bg-primary">
									<i className="fas fa-file-alt text-white"></i>
								</div>
							</div>
							<div>
								<div className="small text-gray-500">
									December 12, 2019
								</div>
								<span className="font-weight-bold">
									A new monthly report is ready to download!
								</span>
							</div>
						</a>
						<a
							className="dropdown-item d-flex align-items-center"
							href="{()=>false}"
						>
							<div className="mr-3">
								<div className="icon-circle bg-success">
									<i className="fas fa-donate text-white"></i>
								</div>
							</div>
							<div>
								<div className="small text-gray-500">
									December 7, 2019
								</div>
								$290.29 has been deposited into your account!
							</div>
						</a>
						<a
							className="dropdown-item d-flex align-items-center"
							href="{()=>false}"
						>
							<div className="mr-3">
								<div className="icon-circle bg-warning">
									<i className="fas fa-exclamation-triangle text-white"></i>
								</div>
							</div>
							<div>
								<div className="small text-gray-500">
									December 2, 2019
								</div>
								Spending Alert: We've noticed unusually high
								spending for your account.
							</div>
						</a>
						<a
							className="dropdown-item text-center small text-gray-500"
							href="{()=>false}"
						>
							Show All Alerts
						</a>
					</div>
				</li> */}

                {/* <li className="nav-item dropdown no-arrow mx-1">
					<a
						className="nav-link dropdown-toggle"
						href="{()=>false}"
						id="messagesDropdown"
						role="button"
						data-toggle="dropdown"
						aria-haspopup="true"
						aria-expanded="false"
					>
						<i className="fas fa-envelope fa-fw"></i>
						<span className="badge badge-danger badge-counter">
							7
						</span>
					</a>
					<div
						className="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
						aria-labelledby="messagesDropdown"
					>
						<h6 className="dropdown-header">Message Center</h6>
						<a
							className="dropdown-item d-flex align-items-center"
							href="{()=>false}"
						>
							<div className="dropdown-list-image mr-3">
								<img
									className="rounded-circle"
									src="img/undraw_profile_1.svg"
									alt="..."
								/>
								<div className="status-indicator bg-success"></div>
							</div>
							<div className="font-weight-bold">
								<div className="text-truncate">
									Hi there! I am wondering if you can help me
									with a problem I've been having.
								</div>
								<div className="small text-gray-500">
									Emily Fowler · 58m
								</div>
							</div>
						</a>
						<a
							className="dropdown-item d-flex align-items-center"
							href="{()=>false}"
						>
							<div className="dropdown-list-image mr-3">
								<img
									className="rounded-circle"
									src="img/undraw_profile_2.svg"
									alt="..."
								/>
								<div className="status-indicator"></div>
							</div>
							<div>
								<div className="text-truncate">
									I have the photos that you ordered last
									month, how would you like them sent to you?
								</div>
								<div className="small text-gray-500">
									Jae Chun · 1d
								</div>
							</div>
						</a>
						<a
							className="dropdown-item d-flex align-items-center"
							href="{()=>false}"
						>
							<div className="dropdown-list-image mr-3">
								<img
									className="rounded-circle"
									src="img/undraw_profile_3.svg"
									alt="..."
								/>
								<div className="status-indicator bg-warning"></div>
							</div>
							<div>
								<div className="text-truncate">
									Last month's report looks great, I am very
									happy with the progress so far, keep up the
									good work!
								</div>
								<div className="small text-gray-500">
									Morgan Alvarez · 2d
								</div>
							</div>
						</a>
						<a
							className="dropdown-item d-flex align-items-center"
							href="{()=>false}"
						>
							<div className="dropdown-list-image mr-3">
								<img
									className="rounded-circle"
									src="https://source.unsplash.com/Mv9hjnEUHR4/60x60"
									alt="..."
								/>
								<div className="status-indicator bg-success"></div>
							</div>
							<div>
								<div className="text-truncate">
									Am I a good boy? The reason I ask is because
									someone told me that people say this to all
									dogs, even if they aren't good...
								</div>
								<div className="small text-gray-500">
									Chicken the Dog · 2w
								</div>
							</div>
						</a>
						<a
							className="dropdown-item text-center small text-gray-500"
							href="{()=>false}"
						>
							Read More Messages
						</a>
					</div>
				</li> */}

                <li className="nav-item dropdown no-arrow mx-1">
                    <Dropdown
                        id={"useLang"}
                        value={props.useLang}
                        options={useLangs}
                        onChange={changeUseLang}
                        name={"useLang"}
                        style={{
                            marginTop: "18px",
                            height: "38px",
                            alignItems: "center",
                        }}
                    ></Dropdown>
                </li>

                {/* <div className="topbar-divider d-none d-sm-block"></div> */}

                <li className="nav-item dropdown no-arrow">
                    <a
                        className="nav-link dropdown-toggle"
                        href="/"
                        id="logoutBtn"
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        onClick={logout}
                    >
                        {/* <span
                            className="mr-2 d-none d-lg-inline"
                            style={{ color: "#fff" }}
                        >
                            Logout
                        </span>
                        <FiLogOut style={{ color: "#fff" }} /> */}

                        <span className="logout-img" />

                        {/* <img
							className="img-profile rounded-circle"
							src="img/undraw_profile.svg"
							alt=""
						/> */}
                    </a>
                    <div
                        className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                        aria-labelledby="userDropdown"
                    >
                        <a className="dropdown-item" href="{()=>false}">
                            <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                            Profile
                        </a>
                        <a className="dropdown-item" href="{()=>false}">
                            <i className="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
                            Settings
                        </a>
                        <a className="dropdown-item" href="{()=>false}">
                            <i className="fas fa-list fa-sm fa-fw mr-2 text-gray-400"></i>
                            Activity Log
                        </a>
                        <div className="dropdown-divider"></div>
                        <a
                            className="dropdown-item"
                            href="{()=>false}"
                            data-toggle="modal"
                            data-target="#logoutModal"
                        >
                            <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                            Logout
                        </a>
                    </div>
                </li>
            </ul>
        </nav>
    );
}
